<template>
    <div class="Wrapper">
        <div class="headingWizard hidePrint">
            Confirmation of Appointment
        </div>
        <div class="contentSection">
            <div class="maxWidth">
                <div class="ackDetails printmargin">
                    <p><b>Thank you!</b></p>
                    <p>
                        You have successfully scheduled your appointment at Land Transport Authority Customer Service
                        Centre,
                        10 Sin Ming Drive, Singapore 575701. An SMS and/or email notification will be sent to you
                        shortly.
                    </p>

                    <ul class="listBullet">
                        <li>
                            Please arrive 15 minutes ahead of your appointment time. If you are late, your appointment
                            may be
                            delayed or cancelled.
                        </li>
                        <li>
                            When you arrive, obtain a queue number at the self-help kiosk by scanning the QR code
                            provided in the
                            email, or by entering the Appointment Reference ID
                            <b>{{ appointmentDetails.referenceNumber }}</b>.
                        </li>
                    </ul>


                    <div v-html="appointmentDetails.postBookingMessage" class="postMessageMargin"></div>
                    <div v-html="appointmentDetails.oldPostBookingMessage" class="postMessageMargin"></div>
                </div>

                <div class="infoTable ackPage printmargin">
                    <table>
                        <thead>
                            <tr>
                                <th>
                                    <div class="lableText"><i> Appointment Date </i></div>
                                    <div class="detailsText">
                                        {{ formatApptDate(appointmentDetailsAppointmentDate) }}
                                    </div>
                                </th>
                                <th>
                                    <div class="lableText"><i> Appointment Time </i></div>
                                    <div class="detailsText">
                                        {{ formatTime12(appointmentDetails.startTime) }}
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td colspan="2">
                                    <div class="barCode" v-if="isShowQrcode">
                                        <qrcode-vue :value="value" size="150" level="H" />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                        <tbody>
                            <tr>
                                <td colspan="2">
                                    <div class="lableText">Name</div>
                                    <div class="detailsText">{{ appointmentDetails.name }}</div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div class="lableText">Mobile Number</div>
                                    <div class="detailsText">
                                        <span v-if="appointmentDetails.phoneNumber">
                                            <span class="hidePrint">{{ appointmentDetails.phoneNumber }}</span>
                                            <span class="hideOnView">
                                                {{ maskingText(appointmentDetails.phoneNumber, 4) }}
                                            </span>
                                        </span>
                                        <span v-else>-</span>
                                    </div>
                                </td>
                                <td>
                                    <div class="lableText">Email Address</div>
                                    <div class="detailsText">
                                        <span v-if="appointmentDetails.email">
                                            <span class="hidePrint">{{ appointmentDetails.email }}</span>
                                            <span class="hideOnView">{{ emailMask(appointmentDetails.email) }}</span>
                                        </span>
                                        <span v-else>-</span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                        <tbody>
                            <tr>
                                <td>
                                    <div class="lableText">Service Name</div>
                                    <div class="detailsText">{{ appointmentDetails.serviceName }}</div>
                                </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td colspan="2" class="p-0">
                                    <div class="appInfoDetails" v-if="isVehicalShow">
                                        <div class="lableText">Vehicle Number</div>
                                        <div class="detailsText">{{ capitalize(appointmentDetails.vehicleNumber) }}
                                        </div>
                                    </div>
                                    <div class="appInfoDetails" v-if="isNoticeShow">
                                        <div class="lableText">Notice Number</div>
                                        <div class="detailsText">{{ capitalize(appointmentDetails.noticeNumber) }}
                                        </div>
                                    </div>
                                    <div class="appInfoDetails" v-if="isVacShow">
                                        <div class="lableText">VAC Number</div>
                                        <div class="detailsText">{{ capitalize(appointmentDetails.vacNumber) }}</div>
                                    </div>
                                    <div class="appInfoDetails" v-if="isPARFShow">
                                        <div class="lableText">PARF Number</div>
                                        <div class="detailsText">{{ capitalize(appointmentDetails.parfNumber) }}</div>
                                    </div>
                                    <div class="appInfoDetails" v-if="isCEORShow">
                                        <div class="lableText">COE Number</div>
                                        <div class="detailsText">{{ capitalize(appointmentDetails.coeNumber) }}</div>
                                    </div>
                                    <div class="appInfoDetails" v-if="isTcoeShow">
                                        <div class="lableText">TCOE Number</div>
                                        <div class="detailsText">{{ capitalize(appointmentDetails.tcoeNumber) }}</div>
                                    </div>
                                    <div class="appInfoDetails" v-if="ishVParkShow">
                                        <div class="lableText">HV Park Number</div>
                                        <div class="detailsText">{{ capitalize(appointmentDetails.hvParkNumber) }}
                                        </div>
                                    </div>
                                    <div class="appInfoDetails" v-if="isDeviceNumberShow">
                                        <div class="lableText">Device Number</div>
                                        <div class="detailsText">{{ capitalize(appointmentDetails.deviceNumber) }}
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2">
                                    <div class="lableText">Notes to LTA</div>
                                    <div class="detailsText" v-html="appointmentDetails.remarks"></div>
                                </td>
                            </tr>
                        </tbody>
                        <tbody>
                            <tr>
                                <td>
                                    <div class="lableText">Appointment Reference ID</div>
                                    <div class="detailsText">{{ appointmentDetails.referenceNumber }}</div>
                                </td>
                                <td>
                                    <div class="lableText">Transaction Date & Time</div>
                                    <div class="detailsText">
                                        {{ appointmentDetailsTransactDateTime }}
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <p class="printmargin">
                    Your appointment will be at Land Transport Authority Customer Service Centre, 10 Sin Ming Drive,
                    Singapore 575701.
                </p>
                <div class="buttonContainer hidePrint">
                    <div class="magBtn">
                        <div class="leftButtons">
                            <Button label="< Home" @click="onHomeclick" class="linkBtn customLinkCss" />
                        </div>
                        <div class="rightButtons">
                            <Button @click="saveAsPdf" label="Save as PDF" class="btn p-button-raised" />
                            <Button label="Print" @click="printWindow" class="btn p-button-raised" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onBeforeMount, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import QrcodeVue from 'qrcode.vue';
import { useApiService } from '@/utils/useApiService';
import { useNotifications } from '@/utils/useNotifications';
const { notifyError, notifyInfoError } = useNotifications()
const { fetchWrapperForGet } = useApiService()
const store = useStore();
const router = useRouter();

const value = ref('');
const url = ref('');
const isShowQrcode = ref(false);

const isVehicalShow = ref(false);
const isNoticeShow = ref(false);
const isVacShow = ref(false);
const isPARFShow = ref(false);
const isCEORShow = ref(false);
const isTcoeShow = ref(false);
const ishVParkShow = ref(false);
const isDeviceNumberShow = ref(false);

const appointmentDetailsAppointmentDate = ref('');
const appointmentDetailsTransactDateTime = ref('');
const appointmentDetails = ref({
    name: '',
    phoneNumber: '',
    email: '',
    serviceName: '',
    remarks: '',
    oldPostBookingMessage: '',
    postBookingMessage: '',
    vehicleNumber: '',
    noticeNumber: '',
    vacNumber: '',
    parfNumber: '',
    coeNumber: '',
    tcoeNumber: '',
    hvParkNumber: '',
    deviceNumber: '',
    referenceNumber: '',
    appointmentDate: '',
    appointmentDateTime: '',
    generateDateTime: '',
    startTime: '',
    endTime: '',
    id: null
});

onBeforeMount(() => {
    appointmentDetails.value = store.getters.getAppointmentAcknowlegement;
    appointmentDetailsAppointmentDate.value = appointmentDetails.value.appointmentDate;
    appointmentDetailsTransactDateTime.value = store.getters.getTransactionDateString;

    store.dispatch('reset').then(() => {
        if (appointmentDetails.value.id) {
            isShowQrcode.value = true;
            url.value = `api/api/appointments/file?pdfType=appointment`;
            value.value = appointmentDetails.value.referenceNumber;
        } else {
            fetchWrapperForGet('api/MopSessions/Delete', false, false, true).then(() => {
                store.dispatch('reset').then(() => {
                    router.push({ path: '/' });
                });
            });
        }
    });
});
function formatApptDate(value) {
    if (!value) return ''

    let dateObj

    if (typeof value === 'string') {
        const dtTimeArray = value.split('T')
        dateObj = new Date(dtTimeArray[0])
    } else if (value instanceof Date) {
        dateObj = value
    } else {
        return ''
    }

    const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ]
    const days = [
        "Sunday", "Monday", "Tuesday", "Wednesday",
        "Thursday", "Friday", "Saturday"
    ]

    return `${dateObj.getDate()} ${monthNames[dateObj.getMonth()]} ${dateObj.getFullYear()}, ${days[dateObj.getDay()]}`
}
function maskingText(val, lastCharCount) {
    const s = String(val);
    return s.length > lastCharCount
        ? '*'.repeat(s.length - lastCharCount) + s.slice(-lastCharCount)
        : s;
}
function formatTime12(value) {
    if (value) {
        const [hoursStr, minutesStr] = value.split(':');
        let hours = parseInt(hoursStr, 10);
        const minutes = parseInt(minutesStr, 10);
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12; // convert 0 to 12 for 12-hour format

        return `${hours}:${String(minutes).padStart(2, '0')} ${ampm}`;
    }
    return value;
}
function emailMask(email) {
    const masked = email
        .split('')
        .map((ch, i) => (i <= email.indexOf('@') ? ch : '*'))
        .join('');
    return masked;
}

function onHomeclick() {
    store.dispatch('reset').then(() => {
        router.push({ path: '/' });
    });
}
function capitalize(value) {
    if (!value) return "";
    value = value.toString();
    return value.toUpperCase();
}
function printWindow() {
    window.print();
}

function saveAsPdf() {
    fetchWrapperForGet('api/HeartBeat', false, false, false)
        .then(() => window.open(url.value))
        .catch((err) => {
            if (err.errorCode === 422) {
                notifyInfoError(
                    'Your session has expired due to inactivity. To download appointment details, please select "Enquire / Manage Appointment" option and try again.',
                    okFunction
                );
            } else {
                notifyError(err);
            }
        });
}

function okFunction() {
    fetchWrapperForGet('api/MopSessions/Delete', false, false, true).then(() => {
        store.dispatch('reset').then(() => {
            router.push({ path: '/' });
        });
    });
}

// replicate your old watchers
watch(() => appointmentDetails.value.vehicleNumber, (v) => {
    if (v) isVehicalShow.value = true;
});
watch(() => appointmentDetails.value.noticeNumber, (v) => {
    if (v) isNoticeShow.value = true;
});
watch(() => appointmentDetails.value.vacNumber, (v) => {
    if (v) isVacShow.value = true;
});
watch(() => appointmentDetails.value.parfNumber, (v) => {
    if (v) isPARFShow.value = true;
});
watch(() => appointmentDetails.value.coeNumber, (v) => {
    if (v) isCEORShow.value = true;
});
watch(() => appointmentDetails.value.tcoeNumber, (v) => {
    if (v) isTcoeShow.value = true;
});
watch(() => appointmentDetails.value.hvParkNumber, (v) => {
    if (v) ishVParkShow.value = true;
});
watch(() => appointmentDetails.value.deviceNumber, (v) => {
    if (v) isDeviceNumberShow.value = true;
});

</script>

<style>
.postMessageMargin {
    margin-bottom: 20px;
}

.postMessageMargin p {
    margin: 0;
}

/* (rest of your styles unchanged) */
.buttonContainer .magBtn {
    margin-top: 20px;
}

.infoTable thead th .lableText {
    color: #ececec;
    font-weight: normal;
}

.buttonContainer .magBtn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    /* Optional: helps with responsiveness */
    padding: 10px;
}

.leftButtons {
    flex: 1;
    display: flex;
    justify-content: flex-start;
}

.rightButtons {
    display: flex;
    gap: 10px;
    /* Space between buttons */
    justify-content: flex-end;
}

.lableText {
    font-weight: normal;
    color: #777777;
}

.maxWidth {
    max-width: 840px;
    margin: 0 auto;
    width: 100%;
}

.ackDetails {
    margin-top: 70px !important;
}

@media print {
    .hidePrint {
        display: none !important;
    }

    .hideOnView {
        display: block !important;
    }

    .printmargin {
        margin-left: 30px;
    }
}

button.p-button.p-component.btn.p-button-raised {
    background-color: #8290d0;
    border: none;
    border-radius: 8px;
    box-shadow: none;
    height: 38px;
}

.barCode {
    display: flex;
    justify-content: center;
}
</style>
